import { render } from "./MatchingMedia.vue?vue&type=template&id=8a49dec6&scoped=true&mode=ios"
import script from "./MatchingMedia.vue?vue&type=script&lang=js"
export * from "./MatchingMedia.vue?vue&type=script&lang=js"

import "./MatchingMedia.vue?vue&type=style&index=0&id=8a49dec6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a49dec6"]])

export default __exports__